import {
  Avatar,
  Button,
  Flex,
  Skeleton,
  Text,
  Title,
  useMantineTheme,
} from "@mantine/core";
import { Profile } from "iconsax-react";
import { client_selected } from "../../client";
import TagCapsules from "../Tags/TagCapsules";
import {
  tradutorCategory,
  tradutorSubcategory,
} from "../../utils/SubCategorys";
import { IColor } from "../../utils/selectColors";
import {
  ECategoryType,
  ESubcategoryType,
} from "../../interfaces/Products/IProductDetail";
import { useTranslation } from "react-i18next";

interface IProps {
  avatar?: string;
  name: string;
  title: string;
  subtitle?: string;
  analyst?: string;
  transparent?: boolean;
  backgroundName?: string;
  colorWhite?: boolean | false;
  isLoading?: boolean;
  category?: ECategoryType;
  subcategory?: ESubcategoryType;
}

const HeaderItem: React.FC<IProps> = ({
  avatar,
  colorWhite,
  isLoading,
  name,
  backgroundName,
  title,
  subtitle,
  analyst,
  category,
  subcategory,
}: IProps) => {
  const { t } = useTranslation();
  const theme = useMantineTheme();
  const isGenial = client_selected.name === "Genial";
  return (
    <Flex
      gap="24px"
      align="center"
      mih="54px"
      wrap={{ base: "wrap", 500: "nowrap" }}
    >
      {!isGenial ? (
        isLoading ? (
          <Skeleton height={80} mb="xl" width={80} />
        ) : (
          <Avatar
            component="span"
            variant="outline"
            size={80}
            radius={8}
            src={avatar}
            alt="Nome do parceiro"
            bg={colorWhite ? theme.colors.basic[0] : ""}
            sx={{
              border: "1px solid",
              borderColor: theme.colors.basic[2],
              padding: "18px",
              img: {
                objectFit: "contain",
              },
            }}
          >
            <Profile color={theme.colors.basic[5]} size={50} />
          </Avatar>
        )
      ) : null}

      <Flex
        justify="space-between"
        direction="column"
        h="fit-content"
        gap={"4px"}
      >
        {isLoading ? (
          <Skeleton height={25} width={100} mb={4} />
        ) : (
          <Flex gap="8px">
            <Text
              bg={backgroundName || theme.colors.basic[1]}
              tt="uppercase"
              fw={700}
              size={12}
              lh="25px"
              color="basic.4"
              style={{
                padding: "4px 8px",
                width: "fit-content",
                borderRadius: "8px",
              }}
            >
              {name}
            </Text>
            {category ? (
              <TagCapsules colorTag={IColor.orange} border>
                {t(tradutorCategory(category).title)}
              </TagCapsules>
            ) : null}
            {subcategory ? (
              <TagCapsules colorTag={IColor.yellow} border>
                {t(tradutorSubcategory(subcategory).title)}
              </TagCapsules>
            ) : null}
          </Flex>
        )}
        <Flex align={"start"} wrap="wrap" direction={"column"} gap="2px">
          {isLoading ? (
            <>
              <Skeleton height={32} width={250} mb={4} />
              <Skeleton height={22} width={100} />
              <Skeleton height={22} width={100} />
            </>
          ) : (
            <>
              <Title
                tt="uppercase"
                fw={700}
                fz={32}
                lh="50px"
                color={
                  colorWhite ? theme.colors.basic[0] : theme.colors.basic[5]
                }
                mr="5px"
              >
                {title}
              </Title>
              {isGenial && analyst ? (
                <Text
                  span
                  fz={16}
                  lh="22px"
                  color={
                    colorWhite
                      ? theme.colors.primary[1]
                      : theme.colors.primary[0]
                  }
                  fw={600}
                  w="fit-content"
                  style={{ whiteSpace: "nowrap" }}
                >
                  {analyst}
                </Text>
              ) : null}
              {!!subtitle ? (
                <Text
                  span
                  fz={16}
                  lh="22px"
                  color={
                    colorWhite ? theme.colors.basic[0] : theme.colors.basic[5]
                  }
                  fw={400}
                  w="fit-content"
                  style={{ whiteSpace: "nowrap" }}
                >
                  {subtitle}
                </Text>
              ) : null}
            </>
          )}
        </Flex>
      </Flex>
    </Flex>
  );
};

export default HeaderItem;
